import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=3e31edb2";
import script from "./qrcode.vue?vue&type=script&lang=js";
export * from "./qrcode.vue?vue&type=script&lang=js";
import style0 from "./qrcode.vue?vue&type=style&index=0&id=3e31edb2&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;